{
	"title": "Slim besparen, zeker passen.",
	"lead": "Navulling voor je wisser die <strong>zeker past</strong>, en tot <strong>de helft minder per doek</strong> in het grote pak.",
	"welcomeBack": {
		"label": "Bestel opnieuw",
		"title": "Welkom terug, {{name}}.",
		"titleNoName": "Welkom terug.",
		"lastOrder": "Je laatste bestelling, {{date}}:",
		"line": "{{count}}× · {{price}}",
		"skipped": "Gaat niet mee, want niet meer te koop of uitverkocht: {{products}}."
	},
	"promise": {
		"label": "Levering",
		"delivery": "Vóór 17:00 besteld, vandaag verstuurd.",
		"noSubscription": "Geen abonnement nodig."
	},
	"picker": {
		"question": "Kies je wisser",
		"size": "Doekjes {{size}}",
		"noSize": "Navulling voor je {{holder}}",
		"from": "vanaf",
		"perPiece": "per {{noun}}",
		"yours": "Jouw wisser",
		"measure": "Weet je niet welke je hebt? Zo meet je je wisser."
	},
	"saving": {
		"title": "Zo betaal je de helft.",
		"intro": "Hetzelfde doekje, in een groter pak. We vergelijken alleen onze eigen pakken.",
		"inPack": "per {{noun}} in het pak van {{count}}",
		"percent": "{{percent}}% minder per {{noun}}"
	},
	"bigPacks": {
		"title": "De grote pakken",
		"intro": "De laagste prijs per doek, per lijn.",
		"fit": "Past op {{holder}}",
		"more": "Bekijk alles"
	},
	"starters": {
		"title": "Nog geen wisser? Begin met de starterkit.",
		"intro": "Een houder en de eerste doekjes. Daarna bestel je alleen nog navulling.",
		"fit": "Voor {{pieces}} {{size}}",
		"pieces": "stuks",
		"pieces_doek": "doekjes",
		"pieces_navulling": "navullingen"
	},
	"why": {
		"title": "Waarom je hier koopt",
		"intro": "Wie je bestelling verstuurt, en wanneer.",
		"introWithReviews": "Reviews van kopers, en wie je bestelling verstuurt.",
		"reviews": {
			"label": "Reviews van kopers"
		},
		"delivery": {
			"title": "Levering"
		},
		"who": {
			"title": "Wie erachter zit",
			"text": "Richard Heemsbergen verkoopt de navullingen vanuit Rhenen.",
			"link": "Over ons"
		},
		"returns": {
			"title": "Retourneren",
			"text": "[NOG INVULLEN: retourtermijn en voorwaarden]",
			"link": "Verzenden en retourneren"
		}
	},
	"business": {
		"title": "Zakelijk bestellen",
		"intro": "Voor schoonmaakbedrijven, kantoren en hotels.",
		"exclVat": {
			"title": "Prijzen excl. btw",
			"text": "Maak een account en kies in je account voor prijzen excl. btw. Na goedkeuring staat het er standaard op."
		},
		"onAccount": {
			"title": "Betalen op rekening",
			"text": "Binnen {{term}}."
		},
		"quantityDiscount": {
			"title": "Staffelkorting",
			"text": "Vanaf {{discount}}."
		},
		"bulk": {
			"title": "Grootverpakking",
			"text": "Formaten: {{packs}}."
		},
		"link": "Naar Zakelijk"
	},
	"newsletter": {
		"title": "Meld je aan voor de nieuwsbrief",
		"welcome": "Je krijgt een welkomstcode in je mail: {{discount}}."
	}
}
